﻿import { Component, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {SubjectsStorage} from '../../subjects/subjects-storage';
import {Subscription, combineLatest} from 'rxjs';
import { map } from 'rxjs/operators';
import {Subject} from '../../subjects/subject';
import {Site} from '../../sites/site';
import {UrlBuilder} from '../../core';
import { routeData } from '../../shared/route-helpers';


@Component({
    selector: 'subjects-root',
    template: require('./subjects-root.component.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubjectsRootComponent implements OnDestroy {
    public noSubjects = false;
    private subscription: Subscription;

    constructor(
        private subjectsStorage: SubjectsStorage,
        route: ActivatedRoute,
        private urlBuilder: UrlBuilder) {

        const subjects = route.data
            .pipe(map(x => x['subjects'] as Subject[]));

        const site = route.parent.parent.data
            .pipe(map(x => x[routeData.selectedSite] as Site));

        this.subscription = combineLatest(site, subjects)
            .subscribe((data: [Site, Subject[]]) => this.onSubjectsLoad(data[0], data[1]));
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    private onSubjectsLoad = (site: Site, subjects: Subject[]) => {

        this.noSubjects = subjects.length === 0;
        if (!this.noSubjects) {
            const zcSubjectId = this.subjectsStorage.lastVisitedZcSubjectId;
            const selectedSubject = subjects.find(s => s.zcSubjectId === zcSubjectId) || subjects[0];
            this.urlBuilder.esa().site(site).subject(selectedSubject).navigate({ navigationExtras: { replaceUrl: true } });
        }
    }
}